// @flow
import trackError from 'utils/trackError';

type SetErrorAction = {
  type: 'SET_ERROR',
  error: Error
};

export type Action = SetErrorAction;

export const setError = (
  error: Error,
  track?: boolean = true
): SetErrorAction => {
  if (track) {
    trackError(error);
  }
  return { type: 'SET_ERROR', error };
};
